export default {
  features: {
    applicationCompletion: {
      sendSms: 'Отправить смс для подтверждения выдачи рассрочки',
      warnings: ['После подтверждениярассрочку нельзя отменить', 'Вы теперь являетесь доверенным лицом Alif'],
      checkboxLabel: 'Продавец отделил и передал товар(ы) для Alif Moliya',
      smsWasSent: 'СМС-код был отправлен на номер клиента',
      fields: {
        code: {
          label: 'Код из СМС',
        },
      },
      request: 'Оформить',
      confirm: 'Потвердить',
      cancel: 'Отмена',
    },
  },
};
